"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkPreviewHeadMeta = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const opengraph_1 = require("./opengraph");
const twitter_1 = require("./twitter");
/**
 * A link preview to represent a web page. Renders a page head containing metadata
 * used by preview platforms, e.g. Facebook/Twitter to render previews
 */
function LinkPreviewHeadMeta({ linkPreview }) {
    const facebookImage = linkPreview.facebookImage;
    const twitterImage = linkPreview.twitterImage;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [facebookImage && ((0, jsx_runtime_1.jsx)(opengraph_1.OpenGraphHead, { title: linkPreview.title, description: linkPreview.description, url: linkPreview.canonicalUrl, image: facebookImage })), twitterImage && ((0, jsx_runtime_1.jsx)(twitter_1.TwitterCardHead, { title: linkPreview.title, description: linkPreview.description, image: twitterImage }))] }));
}
exports.LinkPreviewHeadMeta = LinkPreviewHeadMeta;
//# sourceMappingURL=index.js.map